import React, { useCallback, useState } from 'react'
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material'
import { FormTemplatesGrid } from './form-templates-grid.component'
import makeStyles from '@mui/styles/makeStyles'
import { useFormContext } from 'react-hook-form'
import ListIcon from '@mui/icons-material/List'
import { SummaryTemplate, Template } from '@shared/types'

interface Props {
  requirementBaseID: number
}

export const FormAuditorAssessmentTemplates = ({
  requirementBaseID,
}: Props) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const { register, setValue, watch } = useFormContext()
  const auditorAssessment = watch('auditorAssessment')

  const handleToggleTemplates = useCallback(() => {
    setIsOpen((prevState) => !prevState)
  }, [])

  const handleSelectTemplate = useCallback(
    (template: Template | SummaryTemplate) => {
      setValue('auditorAssessment', template.description)
      setValue('selectedTemplate', template)
      setIsOpen(false)
    },
    [setIsOpen]
  )

  return (
    <>
      <Grid>
        <FormControlLabel
          control={
            <Checkbox
              {...register('saveAssesmentAsTemplate')}
              color="primary"
            />
          }
          label="Zapisz jako szablon"
          disabled={!auditorAssessment}
        />
      </Grid>
      {isOpen && (
        <FormTemplatesGrid
          requirementBaseID={requirementBaseID}
          type="auditorAssessment"
          onSelectTemplate={handleSelectTemplate}
        />
      )}
      <Grid container>
        <Grid item xs={8} className={classes.actionButtonsContainer}>
          <Button
            onClick={handleToggleTemplates}
            variant="text"
            color="primary"
            startIcon={<ListIcon />}
          >
            {isOpen ? 'Zamknij szablony' : 'Szablony'}
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export const useStyles = makeStyles({
  actionButtonsContainer: {
    alignItems: 'center',
    display: 'flex',
  },
})
